import type { NDateLocale } from './enUS'
import { te } from 'date-fns/locale'

const dateTeIN: NDateLocale = {
  name: 'te-IN',
  locale: te
}

export default dateTeIN
